import React from 'react'
import { motion } from 'framer-motion'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-max py-12">
        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {/* Logo */}
          <div className="flex items-center justify-center space-x-2 mb-6">
            <img 
              src="/images/emdrplus-logo eye.png" 
              alt="EMDR Plus Logo" 
              className="w-8 h-8 object-contain"
            />
            <div className="flex items-baseline space-x-1">
              <span className="text-xl font-bold text-white">EMDR</span>
              <span className="text-xl font-normal text-gray-300">Plus</span>
            </div>
          </div>

          {/* Description */}
          <p className="text-gray-400 max-w-2xl mx-auto mb-8">
            La solution de stimulation bilatérale qui facilite la pratique de l'EMDR. 
            Conçue par et pour des thérapeutes professionnels.
          </p>

          {/* Links */}
          <div className="flex justify-center space-x-8 mb-8">
            <a 
              href="#" 
              className="text-gray-400 hover:text-white transition-colors duration-200"
            >
              Mentions Légales
            </a>
            <a 
              href="#" 
              className="text-gray-400 hover:text-white transition-colors duration-200"
            >
              Politique de Confidentialité
            </a>
            <a 
              href="#" 
              className="text-gray-400 hover:text-white transition-colors duration-200"
            >
              Contact
            </a>
          </div>

          {/* Copyright */}
          <div className="border-t border-gray-800 pt-8">
            <p className="text-gray-400 text-sm">
              © 2025 EMDR Plus. Tous droits réservés.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  )
}

export default Footer 